import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { LiteUser } from './model/lite-user';
import { Resource } from '../model/resource';
import { Site } from '../model/site';
import { Roulage } from './model/roulage';

@Injectable({
  providedIn: 'root',
})
export class RoulageService {
  constructor(private http: HttpClient) {}

  getUsers() {
    return this.http.get('/api/roulage/users').pipe(
      map((users: any[]) => {
        return users.map((user) => new LiteUser(user));
      })
    );
  }

  addNewReport(report: Roulage) {
    return this.http.post('/api/roulage/report', report);
  }

  addNewRoulage(roulage: Roulage) {
    return this.http.post('/api/roulage', roulage);
  }

  getUnlockedResources() {
    return this.http.get('/api/booking/resources').pipe(
      map((data: any[]) => {
        return data
          .map((value) => new Resource(value))
          .filter((resource) => !resource.lock);
      })
    );
  }

  getMyRoulages() {
    return this.http.get('/api/roulage/my').pipe(
      map((data: any[]) => {
        return data.map((value) => new Roulage(value));
      })
    );
  }

  /**
   * Les roulages du jour, tout le SDIS -- pas seulement les miens. C'est ce que
   * la bannière "Aujourd'hui au SDIS" ajoute aux cours Ecawin.
   */
  getTodayRoulages() {
    return this.http.get('/api/roulage/today').pipe(
      map((data: any[]) => {
        return data.map((value) => new Roulage(value));
      })
    );
  }

  getAllRoulages() {
    return this.http.get('/api/roulage/report');
  }

  getConflicts(reservation: any) {
    return this.http.post('/api/booking/reservations/conflicts', reservation);
  }

  getMyRoulagesForToday() {
    return this.http.get('/api/roulage/my?date=today').pipe(
      map((data: any[]) => {
        return data.map((value) => new Roulage(value));
      })
    );
  }

  getSites() {
    return this.http.get('/api/booking/resources/sites').pipe(
      map((data: any[]) => {
        return data.map((value) => new Site(value));
      })
    );
  }

  getRoulagesBySite(siteId: number, selectedYear: number) {
    return this.http.get(
      '/api/roulage/report/site/' + siteId + '?year=' + selectedYear
    );
  }

  getFormationsBySite(siteId: number, selectedYear: number) {
    return this.http.get(
      '/api/roulage/formations/site/' + siteId + '?year=' + selectedYear
    );
  }

  deleteRoulage(roulageId: number) {
    return this.http.delete('/api/roulage/' + roulageId);
  }

  exportCsv(site: Site, selectedYear: number) {
    return this.http.post(
      '/api/roulage/reports/' + site.id + '?year=' + selectedYear,
      null,
      {
        responseType: 'blob',
      }
    );
  }
}
